import { Divider, Skeleton } from '@mui/material'
import {
  AttachFilesModal,
  AutentiqueLinkModal,
  NfeModal,
  useAttachFilesStore,
  useAutentiqueModalStore,
  useProofPaymentStore,
  useRejectProposalStore
} from 'modules/orders/components'
import ProofPaymentModal from 'modules/orders/components/proofPayment/proofPayment'
import RejectProposalModal from 'modules/orders/components/rejectProposal/rejectProposal'
import { AttachFiles } from './attachFiles'
import {
  SendSignedProposalModal,
  useSendSignedProposalStore
} from 'modules/orders/components/sendSignedProposal'
import Tracking from 'modules/orders/components/Tracking/Tracking'
import { useTrackingModalStore } from 'modules/orders/components/Tracking/trackingModalStore'
import { useLoadOrderActions } from 'modules/orders/hooks'
import { Fragment } from 'react'
import { StyledMenu } from '../styledMenu'
import { Accompaniments } from './accompaniments'
import { AutentiqueLink } from './autentiqueLink'
import { DuplicateOrder } from './duplicateOrder'
import { EditProposal } from './edit'
import { FutureDelivery } from './futureDelivery'
import { LostProposal } from './lostProposal'
import { NFEDownload } from './nfeDownload'
import { OrderFullPdf } from './orderFullPdf'
import { OrderPdf } from './orderPdf'
import { PendingReview } from './pendingReview'
import { ApproveReserveOrderLink } from './approveReserveOrderLink'
import { ProofPayment } from './proofPayment'
import { ProposalPdf } from './proposalPdf'
import { SendSignedProposal } from './sendSignedProposal'
import { SendToReview } from './sendToReview'
import { TurnOrder } from './turnOrder'
import { UpdateDeliveryDate } from './updateDeliveryDate'
import {
  LostProposalModal,
  useLostProposalModalStore
} from 'modules/orders/components/LostProposalModal'
import {
  TurnOrderModal,
  useTurnOrderStore
} from 'modules/orders/components/turnOrderModal'
import { useNfeModalStore } from 'modules/orders/components/NfeModal/NfeModalStore'
import { GenerateFinancialLead } from './generateLead'

export type ActionsItemProps = {
  order: {
    orderId: any
    totalOrder: number
    proposalId: string
    customer: {
      id: string
      name: string
      city: string
      state: string
    }
    isDraft?: any
    status?: {
      id: string
    }
    nf?: number
    simulationId?: string
    total: any
  }
  disabled?: boolean
}

type ActionProps = ActionsItemProps & {
  anchorEl: any
  open: boolean
  onClose: () => void
}

export const OrderActions = {
  EDIT_PROPOSAL: 'editProposal',
  SEND_TO_REVIEW: 'sendToReview',
  ACCOMPANIMENTS: 'accompaniments',
  PENDING_REVIEW: 'pendingReview',
  APPROVE_RESERVE_ORDER_LINK: 'approveReserveOrderLink',
  PROOF_PAYMENT: 'proofPayment',
  AUTENTIQUE_LINK: 'autentiqueLink',
  SEND_SIGNED_PROPOSAL: 'sendSignedProposal',
  PROPOSAL_PDF: 'proposalPdf',
  FULL_PROPOSAL_PDF: 'fullProposalPdf',
  ORDER_PDF: 'orderPdf',
  FULL_ORDER_PDF: 'fullOrderPdf',
  NFE_DOWNLOAD: 'nfeDownload',
  TURN_ORDER: 'turnOrder',
  CANCEL_PROPOSAL: 'cancelProposal',
  UPDATE_DELIVERY_DATE: 'updateDeliveryDate',
  DUPLICATE_ORDER: 'duplicateOrder',
  FUTURE_DELIVERY: 'futureDelivery',
  CREATE_FINANCIAL_SIMULATION: 'createFinancialSimulation',
  ATTACH_FILES: 'attachFiles'
}

const actionItems = {
  [OrderActions.EDIT_PROPOSAL]: {
    id: OrderActions.EDIT_PROPOSAL,
    Action: EditProposal
  },
  [OrderActions.DUPLICATE_ORDER]: {
    id: OrderActions.DUPLICATE_ORDER,
    Action: DuplicateOrder
  },
  [OrderActions.SEND_TO_REVIEW]: {
    id: OrderActions.SEND_TO_REVIEW,
    Action: SendToReview
  },
  [OrderActions.UPDATE_DELIVERY_DATE]: {
    id: OrderActions.UPDATE_DELIVERY_DATE,
    Action: UpdateDeliveryDate
  },

  [OrderActions.ACCOMPANIMENTS]: {
    id: OrderActions.ACCOMPANIMENTS,
    Action: Accompaniments
  },

  [OrderActions.FUTURE_DELIVERY]: {
    id: OrderActions.FUTURE_DELIVERY,
    Action: FutureDelivery
  },

  [OrderActions.PENDING_REVIEW]: {
    id: OrderActions.PENDING_REVIEW,
    Action: PendingReview
  },

  [OrderActions.APPROVE_RESERVE_ORDER_LINK]: {
    id: OrderActions.APPROVE_RESERVE_ORDER_LINK,
    Action: ApproveReserveOrderLink
  },

  [OrderActions.PROOF_PAYMENT]: {
    id: OrderActions.PROOF_PAYMENT,
    Action: ProofPayment
  },

  [OrderActions.AUTENTIQUE_LINK]: {
    id: OrderActions.AUTENTIQUE_LINK,
    Action: AutentiqueLink
  },

  [OrderActions.SEND_SIGNED_PROPOSAL]: {
    id: OrderActions.SEND_SIGNED_PROPOSAL,
    Action: SendSignedProposal
  },

  [OrderActions.PROPOSAL_PDF]: {
    id: OrderActions.PROPOSAL_PDF,
    Action: ProposalPdf
  },

  // [OrderActions.FULL_PROPOSAL_PDF]: {
  //   id: OrderActions.FULL_PROPOSAL_PDF,
  //   Action: FullProposalPdf
  // },

  [OrderActions.ORDER_PDF]: {
    id: OrderActions.ORDER_PDF,
    Action: OrderPdf
  },

  [OrderActions.FULL_ORDER_PDF]: {
    id: OrderActions.FULL_ORDER_PDF,
    Action: OrderFullPdf
  },

  [OrderActions.NFE_DOWNLOAD]: {
    id: OrderActions.NFE_DOWNLOAD,
    Action: NFEDownload
  },
  [OrderActions.TURN_ORDER]: {
    id: OrderActions.TURN_ORDER,
    Action: TurnOrder
  },
  [OrderActions.CANCEL_PROPOSAL]: {
    id: OrderActions.CANCEL_PROPOSAL,
    Action: LostProposal
  },
  [OrderActions.CREATE_FINANCIAL_SIMULATION]: {
    id: OrderActions.CREATE_FINANCIAL_SIMULATION,
    Action: GenerateFinancialLead
  },
  [OrderActions.ATTACH_FILES]: {
    id: OrderActions.ATTACH_FILES,
    Action: AttachFiles
  }
}

export const Actions = (props: ActionProps) => {
  const { order, anchorEl, open, onClose } = props
  const isAutentiqueOpen = useAutentiqueModalStore.useIsModalOpen()
  const isTrackingOpen = useTrackingModalStore.useIsModalOpen()
  const isProofPaymentOpen = useProofPaymentStore.useIsModalOpen()
  const isSendSignedProposalOpen = useSendSignedProposalStore.useIsModalOpen()
  const isRejectOpen = useRejectProposalStore.useIsModalOpen()
  const isLostOpen = useLostProposalModalStore.useIsModalOpen()
  const isTurnOrderOpen = useTurnOrderStore.useIsModalOpen()
  const isNfeOpen = useNfeModalStore.useIsModalOpen()
  const isAttachFilesOpen = useAttachFilesStore.useIsModalOpen()

  const { data, isFetching } = useLoadOrderActions({
    id: props.order.orderId || props.order.proposalId,
    isProposal: Number(!props.order.orderId)
  })

  return (
    <>
      <StyledMenu
        id="actions-menu"
        MenuListProps={{
          'aria-labelledby': 'simple-popper'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
      >
        <Divider sx={{ my: 0.5 }} />
        {isFetching &&
          [1, 2, 3, 4].map((item) => (
            <div
              key={item}
              style={{
                width: 300,
                display: 'flex',
                justifyContent: 'space-evenly',
                alignItems: 'center'
              }}
            >
              <Skeleton width={30} animation="wave" height={36} />
              <Skeleton width={240} animation="wave" height={36} />
            </div>
          ))}
        {!isFetching &&
          data?.map((item: any) => {
            if (item.hide) return null
            if (!actionItems[item.id]) return null
            const Action = actionItems[item.id].Action
            return (
              <Fragment key={item.id}>
                <Action order={order} disabled={item?.disabled} />
                <Divider sx={{ my: 0.5 }} />
              </Fragment>
            )
          })}
      </StyledMenu>
      {isLostOpen && <LostProposalModal />}
      {isAutentiqueOpen && <AutentiqueLinkModal />}
      {isTrackingOpen && <Tracking />}
      {isProofPaymentOpen && <ProofPaymentModal />}
      {isSendSignedProposalOpen && <SendSignedProposalModal />}
      {isRejectOpen && <RejectProposalModal />}
      {isTurnOrderOpen && <TurnOrderModal />}
      {isNfeOpen && <NfeModal />}
      {isAttachFilesOpen && <AttachFilesModal />}
    </>
  )
}
